import Pochta from "./Pochta";
function ISFP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper" >
      <img src="/img/ISFP Артист.png" className="ISFP"/>
      </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
        <h2>ISFP</h2>
      <p><strong>Процент населения:</strong> 6–8%</p>
<p><strong>Среди мужчин:</strong> 4–6%</p>
<p><strong>Среди женщин:</strong> 7–10%</p>
<p><strong>Стратегия:</strong> Творчество и самовыражение</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ISFP черпают энергию в одиночестве и творчестве. 
  Им нужно время, чтобы погрузиться в свои ощущения и переживания. 
  Они восстанавливают силы через искусство, музыку или природу.
</p>
<p>
  Решения ISFP принимают на основе чувств и внутренней гармонии. 
  Они доверяют своим ощущениям и редко идут против себя. 
  Они ценят красоту, искренность и возможность быть собой.
</p>
<p>
  Это чувствительные и творческие люди. 
  Они всегда замечают красоту там, где другие не видят. 
  Им трудно выражать словами свои чувства, но их искусство говорит за них.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ISFP слишком ранимы. Критика для них — как удар ножом. Они не умеют защищаться, 
  и их легко обидеть. Они живут внутри себя и редко открываются другим, даже близким. 
  Их чувствительность может быть сложной для окружающих.
</p>

<p>
  ISFP — это человек, который может увидеть красоту в трещине на асфальте. 
  Они живут чувствами и впечатлениями, и их душа — холст, где каждый день рисует новый цвет. 
  Их тихая глубина и утончённость делают их одними из самых таинственных людей.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ISFP;